import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {
    FullInternalProcess, InternalProcessOptions,
    JobPipelineTableColumns,
    MemberInternalProcessOptions, ProcessReferInfo, SearchJobPipelineFields
} from "@pages/jobpipeline/common/Constant";
import Select from "react-select";
import {stringToOption} from "@app/utils/CommonUtils";
import {requestGetUserList} from "@app/services/UserService";

export const JobPipelineInputMode = {
    Add: 1,
    Edit: 2,
    Search: 3
}

const RefereeHighlightColumns = {
    'user_qualify_uv': {'color_class': 'text-danger'},
    'todo_with_person': {'color_class': 'text-danger'},
    'internal_process': {'color_class': 'text-danger'},
    'cdd_status': {'color_class': 'text-success'},
    'interactive_channel':{'color_class': 'text-success'}
}

const OnlyAdminColumns = [
    'cdd_to_employer_process', 'payment_and_warranty'
]

const JobPipelineInputForm = (props) => {
    const [jobPipeline, setJobPipeline] = useState({});
    const [inputMode, setInputMode] = useState(null)
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [userSearchOptions, setUserSearchOptions] = useState([]);
    const [disableFields, setDisableFields] = useState([]);
    const [FieldList, setFieldList] = useState([]);

    const {pipeLineInfo, isShow, mode, onClose, onChangeInputItem} = props

    useEffect(() => {
        setInputMode(mode)
        if (mode === JobPipelineInputMode.Search) {
            setFieldList([...SearchJobPipelineFields])
        } else {
            setFieldList([...JobPipelineTableColumns])
        }
    }, [mode])

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users
        const userOptionList = userList.map(user => {
            return  {value: user.id, label : user.email, id: user.id}
        })

        // userOptionList.splice(0, 0, {value: "", label : "Tất cả users", id: ""})
        setUserSearchOptions([...userOptionList])
    };

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)

            if (mode === JobPipelineInputMode.Search) {
                if (loginUser.is_superuser) {
                    fetchUsers()
                } else {
                    setUserSearchOptions(
                        [
                            {value: loginUser.id, label : "Chỉ NL của mình", id: loginUser.id},
                        ]
                    )
                }
            }
        }

    }, [])

    const setJobPipelineInfoForDisplay = (inputJobPipeline) => {
        const pipeline = {...inputJobPipeline}
        pipeline.interactive_channel = stringToOption(pipeline.interactive_channel, false)
        pipeline.ctv_status = stringToOption(pipeline.ctv_status, false)
        pipeline.process_info_from_ctv = stringToOption(pipeline.process_info_from_ctv, false)
        pipeline.refer_status = stringToOption(pipeline.refer_status, false)

        // Trường hợp tạo mới pipeline từ nhập referee, set giá trị mặc định refer_info_process = 'Đã Add vào Pipeline' cho dòng pipeline gốc
        // if (pipeline.fromReferee && (!pipeline.refer_info_process || !pipeline.refer_info_process.value)) {
        //     pipeline.refer_info_process = stringToOption(ProcessReferInfo[1], false)
        // } else {
        //     pipeline.refer_info_process = stringToOption(pipeline.refer_info_process, false)
        // }
        pipeline.refer_info_process = stringToOption(pipeline.refer_info_process, false)

        pipeline.cdd_status = stringToOption(pipeline.cdd_status)
        pipeline.user_qualify_uv = stringToOption(pipeline.user_qualify_uv)
        pipeline.todo_with_person = stringToOption(pipeline.todo_with_person)
        pipeline.internal_process = stringToOption(pipeline.internal_process, false)
        pipeline.cdd_to_employer_process = stringToOption(pipeline.cdd_to_employer_process, false)
        pipeline.payment_and_warranty = stringToOption(pipeline.payment_and_warranty, false)

        setJobPipeline({...pipeline})
    }

    useEffect(() => {
        if (pipeLineInfo) {
            setJobPipelineInfoForDisplay(pipeLineInfo)
            if (pipeLineInfo.fromReferee) {
                setDisableFields(['job_id', 'referer_id', 'candidate_id', 'comment_from_referer'])
            } else {
                setDisableFields([])
            }
        } else {
            setJobPipeline({})
        }
    }, [pipeLineInfo]);

    const onChangeInput = (values, column) => {
        jobPipeline[column.key] = values
        setJobPipeline({...jobPipeline})
        if (onChangeInputItem) {
            onChangeInputItem(values, column)
        }
    }

    const getItemValues = (column, values) => {
        return values || ""
    }

    const getOptions = (column) => {
        if (column.key === 'internal_process') {
            return userLoginInfo.is_superuser ? InternalProcessOptions : MemberInternalProcessOptions
        }

        return column.options
    }

    const highLightLabel = (column) => {
        if (jobPipeline.fromReferee) {
            const refereeHighLight = RefereeHighlightColumns[column.key]
            if (refereeHighLight) {
                return refereeHighLight['color_class']
            }
        }
        return ""
    }

    return (
        <div className='row'>
            {inputMode === JobPipelineInputMode.Search &&
            <>
                <div className={"col-sm-12"}>
                    <label className={"w-100"}>Note time</label>
                    <div className={"row"}>
                        <div className='col-sm-6'>
                            <div className="form-group">
                                <label>From</label>
                                <input type="date"
                                       className="form-control" name={'start_date'}
                                       value={jobPipeline.created_start_date}
                                       onChange={event => onChangeInput(event.target.value, {key: 'created_start_date'})}
                                       maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off"/>
                            </div>
                        </div>
                        <div className={'col-sm-6'}>
                            <div className="form-group">
                                <label className={'w-100'}><b>To</b></label>
                                <input type="date"
                                       className="form-control" name={'end_date'}
                                       value={jobPipeline.created_end_date}
                                       onChange={event => onChangeInput(event.target.value, {key: 'created_end_date'})}
                                       maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-sm-6'>
                    <div className="form-group">
                        <label className={'w-100'}>Phạm vi search</label>
                        <select className='form-control'
                                name={'inputType'}
                                value={jobPipeline.search_scope}
                                onChange={event => onChangeInput(event.target.value, {key: 'search_scope'})}>
                            <option value=''>{"Tất cả các dòng"}</option>
                            <option value={'1'}>{"Loại trừ email mời job"}</option>
                            <option value={'2'}>{"NL mới nhất của cùng 1 cặp Person-Job"}</option>
                        </select>
                    </div>
                </div>
            </>
            }

            {inputMode === JobPipelineInputMode.Search &&
            <div className={'col-sm-6'}>
                <label>NL bởi users</label>
                <Select options={userSearchOptions}
                        isMulti
                        placeholder={"Tất cả users"}
                        value={jobPipeline.created_user}
                        onChange={values => {
                            onChangeInput(values, {key: 'created_user'});
                        }}
                />
            </div>
            }

            {FieldList.map(column => {
                if ((inputMode === JobPipelineInputMode.Add && column.autoAdd)
                    || (inputMode === JobPipelineInputMode.Search && !column.searchable)
                    || (inputMode !== JobPipelineInputMode.Search && OnlyAdminColumns.includes(column.key) && !userLoginInfo.is_superuser)) {
                    return ""
                }

                if (column.inputType === 'option') {
                    return <div className='col-sm-6' key={`update_job_pipeline_input_item_${column.key}`}>
                        <div className='form-group'>
                            <div style={{width: '100%'}}>
                                <label className={`w-100 ${highLightLabel(column)}`}>{column.label}</label>
                                <Select options={getOptions(column)}
                                        value={getItemValues(column, jobPipeline[column.key])}
                                        isDisabled={(inputMode === JobPipelineInputMode.Edit && !column.editable) || disableFields.includes(column.key)}
                                        name={column.key}
                                        isMulti={!!column.isMulti}
                                        onChange={value => {
                                            onChangeInput(value, column);
                                        }}
                                />
                            </div>
                        </div>
                    </div>
                }

                if (column.inputType === 'textarea') {
                    return <div className='col-sm-6' key={`update_job_pipeline_input_item_${column.key}`}>
                        <div className='form-group '>
                            <label className={`w-100 ${highLightLabel(column)}`}>{column.label}</label>
                            <textarea className='form-control'
                                      value={getItemValues(column, jobPipeline[column.key])}
                                      name={column.key}
                                      disabled={(inputMode === JobPipelineInputMode.Edit && !column.editable) || disableFields.includes(column.key)}
                                      onChange={event => onChangeInput(event.target.value, column)}/>
                        </div>
                    </div>
                }

                return <div className='col-sm-6' key={`update_job_pipeline_input_item_${column.key}`}>
                    <div className='form-group'>
                        <label className={'w-100'}>{column.label}</label>
                        <input type={column.inputType} className='form-control'
                               disabled={(inputMode === JobPipelineInputMode.Edit && !column.editable) || disableFields.includes(column.key)}
                               value={getItemValues(column, jobPipeline[column.key])}
                               name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                    </div>
                </div>
            })}
        </div>
    )
}

export default JobPipelineInputForm;
